import React from 'react'
import '../CSS/style.css';

import aboutImage from "../images/about-img.png";
import { NavLink } from 'react-router-dom';
import Svg from '../svg/Svg';

export default function About() {
  return (
    <>
      <section className="about_section layout_padding">
        <div className="container  ">
          <div className="heading_container heading_center">
            <h2>
              About <span>Us</span>
            </h2>
            <p> At Currency Growth Financial Services, we believe that financial success is a collaborative effort</p>
          </div>
          <div className="row">
            <div className="col-md-6 ">
              <div className="img-box">
                {/* <img src={aboutImage} alt="HDFC Logo" /> */}
                <Svg className="img-box-svg"/>
              </div>
            </div>
            <div className="col-md-6">
              <div className="detail-box" alt="HDFC Logo">
                <h3>Who we are</h3>
                <p>
                  Welcome to Currency Growth Financial Services, where financial success meets personalized service. Established with a commitment to empower individuals and businesses, we are more than advisors; we are partners in your journey towards prosperity.
                </p>
                <p>
                  At Currency Growth Financial Services, we believe that financial success is a collaborative effort. We go beyond conventional financial services, fostering a relationship that extends beyond transactions.We take the time to understand your unique financial goals and aspirations, ensuring our strategies are tailored to your individual or business needs.
                </p>
                <NavLink to='/about'>Read More</NavLink>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}
